import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Button } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { isLoadingSelector } from '../../resetPasswordSlice.js';
import { useAppSelector } from '../../../../redux/hooks.js';
export const ResetPasswordButton = ({ onClick }) => {
    const { t } = useTranslation();
    const isLoading = useAppSelector(isLoadingSelector);
    return (_jsx(Button, { autoFocus // it is used to focus on the button first instead of the input fields
        : true, "data-testid": "resetpw-submit-btn", variant: "primary", a11yLabel: "Reset password", type: "submit", onClick: onClick, isLoading: isLoading, isFullWidth: true, size: ['medium'], marginTop: 'spaceS', children: t('loginregistration.resetPassword.button') }));
};
//# sourceMappingURL=ResetPasswordButton.js.map